import type { FC } from 'react';
import { LoadingCircleAnimation, faClock, faMoneyBill } from '~/assets';
import { CreditLimit, If, SceneWrapper, SectionTitle } from '~/components';
import { currencyParser } from '~/modules';
import {
  BenefitCard,
  BenefitCardDescription,
  BenefitCardIcon,
  BenefitCardTitle,
  BenefitsSection,
  ButtonComponent,
  LoadingIndicator,
  WelcomeTitle,
} from './styles';

type CreditSimulationIntroProps = {
  onSubmit: () => void;
  availableLimit: number;
  loading: boolean;
  userName: string;
};

const CreditSimulationIntro: FC<CreditSimulationIntroProps> = ({
  onSubmit,
  availableLimit,
  loading,
  userName,
}) => {
  return (
    <SceneWrapper
      footer={
        <ButtonComponent
          onPress={onSubmit}
          id="button-start-simulation"
          onLoading={loading}
          fullWidth
        >
          SIMULAR AGORA
        </ButtonComponent>
      }
    >
      <If condition={!!loading}>
        <LoadingIndicator options={{ animationData: LoadingCircleAnimation }} />
      </If>
      <If condition={!loading}>
        <WelcomeTitle>Bem vindo(a), {userName}.</WelcomeTitle>
        <SectionTitle>Inicie a contratação do seu Crédito Pessoal</SectionTitle>
        <CreditLimit
          title="Limite disponível pré-aprovado"
          value={currencyParser(availableLimit || '')}
          warningText="Valor total disponível sujeito a análise de crédito"
        />

        <SectionTitle>Conheça os benefícios</SectionTitle>
        <BenefitsSection>
          <BenefitCard>
            <BenefitCardIcon icon={faClock} />
            <BenefitCardTitle>Simples e rápido</BenefitCardTitle>
            <BenefitCardDescription>
              O dinheiro é liberado em sua conta em até 1 dia útil.
            </BenefitCardDescription>
          </BenefitCard>
          <BenefitCard>
            <BenefitCardIcon icon={faMoneyBill} />
            <BenefitCardTitle>Pagamento facilitado</BenefitCardTitle>
            <BenefitCardDescription>
              Baixe o app Realbem e gere o boleto para pagamento.
            </BenefitCardDescription>
          </BenefitCard>
        </BenefitsSection>
      </If>
    </SceneWrapper>
  );
};

export default CreditSimulationIntro;
